import React, { useState, useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import logoAvaliare from "../../images/logo.png";
import ReactToPrint from "react-to-print";
import { getPrintData } from "./Services";

const styles = (theme) => ({
  button: {
    padding: theme.spacing.unit * 3,
  },
  title: {
    marginTop: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 2,
  },
  root: {
    padding: theme.spacing.unit * 2,
  },
  page: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 4,
  },
  itemRoot: {
    marginTop: theme.spacing.unit * 1,
  },
  itemTitle: {
    paddingTop: 32,
    marginLeft: theme.spacing.unit * 2,
  },
  informacoesComplementares: {
    marginLeft: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
  },
  itemColumn: {
    width: 300,
  },
});

const Item = ({ classes, refeicao }) => (
  <Grid container direction="column" spacing={12} className={classes.itemRoot}>
    <Grid item>
      <Typography variant="h6" className={classes.itemTitle}>
        {refeicao.refeicaoTipo} {refeicao.titulo} - {refeicao.horario}
      </Typography>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Refeição</TableCell>
            <TableCell>Receitas</TableCell>
            <TableCell>Medida</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {refeicao.receitas.map((receita) => (
            <TableRow key={receita.id}>
              <TableCell className={classes.itemColumn}>
                {" "}
                {receita.titulo}{" "}
              </TableCell>
              <TableCell
                className={classes.itemColumn}
                dangerouslySetInnerHTML={{ __html: receita.alimentos }}
              />
              <TableCell
                className={classes.itemColumn}
                dangerouslySetInnerHTML={{ __html: receita.medidas }}
              />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Grid>
  </Grid>
);

const Header = ({ cliente, classes }) => (
  <Grid container spacing={24} justify="space-between">
    <Grid item>
      <Typography variant="h5" className={classes.title}>
        {cliente.nome}
      </Typography>
    </Grid>
    <Grid item style={{ padding: 34 }}>
      <img alt="logo avaliare" style={{ width: 200 }} src={logoAvaliare} />
    </Grid>
  </Grid>
);

const Observacoes = ({ classes, cardapio }) => (
  <div className={classes.informacoesComplementares}>
    <Typography variant="subtitle1">Observações:</Typography>
    <Typography
      variant="body1"
      dangerouslySetInnerHTML={{ __html: cardapio.informacoesComplementares }}
    />
  </div>
);

function Impressao({ classes, match }) {
  const [data, setData] = useState();
  let report;

  useEffect(() => {
    getPrintData(match.params.id).then(setData);
  }, []);

  if (!data)
    return (
      <Typography variant="h5" className={classes.root}>
        Carregando...
      </Typography>
    );

  const { cliente, refeicoes, cardapio } = data;
  return (
    <div>
      <div className={classes.button}>
        <ReactToPrint
          trigger={() => <Button color="primary">Imprimir</Button>}
          pageStyle="@page { size: A4 portrait;}"
          content={() => report}
        />
      </div>
      <div className={classes.root} ref={(ref) => (report = ref)}>
        <div className={classes.page}>
          <Header classes={classes} cliente={cliente} />
          {refeicoes.map((r) => (
            <Item key={r.id} refeicao={r} classes={classes} />
          ))}
          <Observacoes classes={classes} cardapio={cardapio} />
        </div>
      </div>
    </div>
  );
}

export default withStyles(styles)(Impressao);
